import { To } from 'react-router-dom';

import { TabProps, Text12SB } from '@sternum/ui';

import { LinkStyled, TabStyled } from './Tab.styles';

export interface HeaderTabProps<ValueType> extends TabProps<ValueType> {
  to?: To;
}

export function Tab<ValueType>({ children, ...props }: TabProps<ValueType>) {
  return (
    <TabStyled role="presentation" aria-label="application header tab" {...props}>
      <Text12SB>{children}</Text12SB>
    </TabStyled>
  );
}

export function TabLink<ValueType>({ children, to = '#', ...props }: HeaderTabProps<ValueType>) {
  return (
    <LinkStyled role="presentation" aria-label="application header tab link" to={to}>
      {({ isActive }) => (
        <TabStyled active={isActive} {...props}>
          <Text12SB>{children}</Text12SB>
        </TabStyled>
      )}
    </LinkStyled>
  );
}
